import { isNil } from 'lodash-es';

export type FetchPageResult<T> = {
  items: T[];
  totalCount?: number;
};

export type FetchPageFn<T> = (
  offset: number,
  perPage: number,
) => Promise<FetchPageResult<T>>;

export async function* fetchAllPages<T>(
  fetchPage: FetchPageFn<T>,
  perPage = 50,
  signal?: AbortSignal,
): AsyncGenerator<T[]> {
  let offset = 0;
  while (true) {
    signal?.throwIfAborted();
    const { items, totalCount } = await fetchPage(offset, perPage);
    if (items.length === 0) break;
    yield items;
    offset += items.length;
    if (!isNil(totalCount) && offset >= totalCount) break;
    if (isNil(totalCount) && items.length < perPage) break;
  }
}

export const collectAllPages = async <T>(
  fetchPage: FetchPageFn<T>,
  perPage = 50,
  signal?: AbortSignal,
): Promise<T[]> => {
  const all: T[] = [];
  for await (const page of fetchAllPages(fetchPage, perPage, signal)) {
    all.push(...page);
  }
  return all;
};
